import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import { FormItemContainer } from '@components/form/FormItemContainer';
import { FormVerticalContainer } from '@components/form/FormVerticalContainer';
import { MessageText } from '@components/text/MessageText';
import { MessageTextArea } from '@components/text/MessageTextArea';
import { useStore } from '@stores/RootStore';
import { fonts } from '@theme/fontsCustomer';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getConditionInputOutputText = (output: any) => {
  if (typeof output === 'undefined') {
    return undefined;
  }

  if (typeof output !== 'string' && typeof output !== 'number') {
    return JSON.stringify(output, null, 2);
  }
  return output.toString();
};

export const ConditionExecView = observer(() => {
  const { t } = useTranslation();
  const { workflowDetailStore } = useStore();

  const conditionNode = workflowDetailStore.findNode(workflowDetailStore.curNodeId ?? '');

  // 조건 노드의 실제 step 번호 찾기
  // actions 배열에서 모든 action/condition 노드를 순회하며 현재 노드의 step을 찾음
  let actionStep = 0;
  if (conditionNode) {
    const nodes = workflowDetailStore.nodes;
    const sortedNodes = [...nodes]
      .filter(n => n.type === 'action' || n.type === 'condition')
      .sort((a, b) => {
        const aIndex = a.data.actionIndex ?? a.data.conditionIndex ?? 0;
        const bIndex = b.data.actionIndex ?? b.data.conditionIndex ?? 0;
        return aIndex - bIndex;
      });

    actionStep = sortedNodes.findIndex(n => n.id === conditionNode.id);
  }
  const conditionExecution = workflowDetailStore.execution?.getActionExecution(actionStep);

  const conditionOutputText = getConditionInputOutputText(conditionExecution?.actionOutput);
  const conditionInputText = getConditionInputOutputText(conditionExecution?.actionArguments);

  return (
    <Container>
      <ToolbarName>{t('Workflow.conditionExec.exec')}</ToolbarName>
      <Body>
        {conditionExecution ? (
          <FormVerticalContainer>
            <FormItemContainer>
              <NameText>{t('Workflow.conditionExec.input')}</NameText>
              <MessageTextArea value={conditionInputText} readOnly />
            </FormItemContainer>
            <FormItemContainer>
              <NameText>{t('Workflow.conditionExec.output')}</NameText>
              <MessageTextArea value={conditionOutputText} readOnly />
            </FormItemContainer>
            <FormItemContainer>
              <NameText>{t('Workflow.statusMsg')}</NameText>
              <MessageText>{conditionExecution.statusMessage}</MessageText>
            </FormItemContainer>
          </FormVerticalContainer>
        ) : (
          <MessageText>{t('Workflow.conditionExec.noExecutionHistory')}</MessageText>
        )}
      </Body>
    </Container>
  );
});

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  background: inherit;
  padding: 36px 32px;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: inherit;
  border: 0px;
  padding: 28px 0 20px;
  position: relative;
`;

const ToolbarName = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 18px;
  ${fonts.Headline7};
  color: ${({ theme: { colors } }) => colors['text-gray-main']};
`;

const NameText = styled.span`
  ${fonts.Headline8}
`;
